module.exports = __webpack_public_path__ + "img/full6-min.35fabc61.png";